/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'SplitContent',
        import: () => import('@stories/Widgets/SplitContent/SplitContent'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Signpost',
        import: () => import('@stories/Widgets/Signpost/Signpost'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'RichTextSection',
        import: () => import('@stories/Widgets/RichTextSection/RichTextSection'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Banner',
        import: () => import('@stories/Widgets/Banner/Banner'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'LandingBanner',
        import: () => import('@stories/Widgets/LandingBanner/LandingBanner'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'FormContactDetails',
        import: () => import('@stories/Widgets/FormContactDetails/FormContactDetails'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Faqs',
        import: () => import('@stories/Widgets/Faqs/Faqs'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'ServicesAndFeatures',
        import: () => import('@stories/Widgets/ServicesAndFeatures/ServicesAndFeatures'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'ReviewCarousel',
        import: () => import('@stories/Widgets/ReviewCarousel/ReviewCarousel'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'CallbackForm',
        import: () => import('@stories/Widgets/CallbackForm/CallbackForm'),
        config: {
            hydrate: 'always',
        },
    },
];
